// external js: flickity.pkgd.js
var cellsButtonGroup = document.querySelector(".button-group--cells");
if (cellsButtonGroup) {
  var utils = window.fizzyUIUtils;

  var carousel = document.querySelector(".Carousel--new");
  var flkty = new Flickity(carousel, {
    prevNextButtons: false,
    pageDots: false,
  });
}